import { updateOdvWebStatus } from 'Api/services/busServices'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  allowedTransitions,
  colorsStatus,
  listOfStatus,
  statusIds,
} from 'Views/OrdenDeVenta/constants/odvStatus'
import { CustomSelector } from 'Views/Printer/components/CustomSelector'
import Modal from '@mui/material/Modal'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

export const DocumentStatusSelector = ({
  documentData,
  odvStatus,
  showHomeDeliveryAddress,
}) => {
  const dispatch = useDispatch()
  const isWebDocument = documentData?.Origin === 'AB'
  const [loading, setLoading] = useState(false)
  const [selectedOption, setSelectedOption] = React.useState({
    value: documentData?.DescriptionStatus,
    key: documentData?.DocHeaderStatusId,
  })
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [pendingCancelOption, setPendingCancelOption] = useState(null)

  const filterList = DocHeaderStatusId => {
    const currentStatusId = DocHeaderStatusId?.toLowerCase()
    if (!currentStatusId || !allowedTransitions[currentStatusId]) {
      return []
    }
    const allowedStatusIds = allowedTransitions[currentStatusId]
    let availableStatuses = listOfStatus.filter(status =>
      allowedStatusIds.includes(status?.key?.toLowerCase())
    )

    if (showHomeDeliveryAddress) {
      availableStatuses = availableStatuses.filter(
        status => status.key !== statusIds.readyToPickUp
      )
    } else {
      availableStatuses = availableStatuses.filter(
        status => status.key !== statusIds.readyToDeliver
      )
    }

    return availableStatuses.sort((a, b) => a.SortOrder - b.SortOrder)
  }

  const filteredStatus = filterList(documentData?.DocHeaderStatusId)

  const notEditable =
    documentData?.DescriptionStatus === 'Cerrada' ||
    documentData?.DescriptionStatus === 'Cancelada' ||
    documentData?.DescriptionStatus === 'Entregado'

  const status = () => {
    const status = documentData?.DescriptionStatus
    return status === 'En proceso de despacho'
      ? colorsStatus.pending
      : status === 'Cerrada'
      ? colorsStatus.closed
      : colorsStatus.process
  }

  const doChangeStatus = async option => {
    setSelectedOption(option)
    try {
      setLoading(true)
      await updateOdvWebStatus({
        saleOrderId: documentData?.DocHeaderId,
        headerStatusId: option.key,
        statusName: option.value,
      })
      dispatch({
        type: 'SELL_ORDER_STATUS',
        payload: {
          value: option.value,
          key: option.key,
        },
      })
    } catch (error) {
      console.error('Error:', error)
      setSelectedOption({
        value: documentData?.DescriptionStatus,
        key: documentData?.DocHeaderStatusId,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleOptionChange = async option => {
    if (option.value === 'Cancelada') {
      setPendingCancelOption(option)
      setShowCancelModal(true)
      return
    }
    await doChangeStatus(option)
  }

  const confirmCancelOrder = async () => {
    setShowCancelModal(false)
    if (pendingCancelOption) {
      await doChangeStatus(pendingCancelOption)
      setPendingCancelOption(null)
    }
  }

  const cancelCancelOrder = () => {
    setShowCancelModal(false)
    setPendingCancelOption(null)
  }

  return (
    <>
      {isWebDocument && (
        <div style={{ width: '100%', marginTop: 10 }}>
          <CustomSelector
            placeholder="Selecciona qué desea visualizar"
            options={filteredStatus}
            selectedOption={selectedOption || {}}
            handleOption={handleOptionChange}
            disabled={notEditable}
            loading={loading}
            styles={{
              width: '100%',
              padding: '0 14px',
              height: '35px',
            }}
          />
        </div>
      )}
      {!isWebDocument && documentData?.DescriptionStatus && (
        <>
          <p
            className="status"
            style={{
              backgroundColor: status(),
              marginRight: 10,
            }}>
            {documentData.DescriptionStatus}
          </p>
          {odvStatus && (
            <p
              className="status"
              style={{ backgroundColor: colorsStatus.pending }}>
              Aprobación de precio pendiente
            </p>
          )}
        </>
      )}
      <Modal
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1300,
        }}
        open={showCancelModal}
        onClose={cancelCancelOrder}>
        <div className="cancel-modal-content" style={{ position: 'relative' }}>
          <IconButton
            aria-label="close"
            onClick={cancelCancelOrder}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}
            size="large">
            <CloseIcon />
          </IconButton>
          <p>
            <b>
              ¿Está seguro que desea cancelar la orden? <br />
              Esta acción no podrá revertirse.
            </b>
          </p>
          <div className="cancel-modal-actions">
            <Button
              onClick={confirmCancelOrder}
              color="primary"
              variant="contained">
              Sí, cancelar orden
            </Button>
            <Button
              onClick={cancelCancelOrder}
              color="primary"
              variant="outlined">
              No, mantener activa
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}
